/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnListHelperService} from '../../common/controller/list-helper.service';
import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Subject} from 'rxjs';
import {BsModalRef} from 'ngx-bootstrap/modal';
import * as _ from 'lodash';
import template from './layout-selector-modal.component.html';
import {LayoutResource} from '../../../components/api/resources/resource/layout.resource';
import {deferMarkForCheck} from '../../common/util/defer-mark-for-check';

@Component({
  standalone: false,
  selector: 'adn-layout-selector-modal',
  template
})
export class LayoutSelectorModalComponent implements OnInit {
  /** Set via BsModalService initialState */
  currentLayouts: any[] = [];

  readonly onSaved = new Subject<any[]>();

  selLayouts: any[] = [];
  items: any[] = [];
  query: any;
  totalCount = 0;
  makeQuery: (() => void) | undefined;
  setMoreParams: ((params: any) => void) | undefined;

  /** Buffered for template — avoids NG0100 when list-helper fills items mid-refresh. */
  listReady = false;
  hasItems = false;
  canLoadMore = false;
  displayItems: any[] = [];

  constructor(
    public bsModalRef: BsModalRef,
    @Inject(LayoutResource) private Layout: any,
    private adnListHelper: AdnListHelperService,
    private readonly translateService: TranslateService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.selLayouts = _.cloneDeep(this.currentLayouts);
    const initSelLayoutIds = _.map(this.selLayouts, 'id');
    this.adnListHelper.setUpBasicList(this, this.Layout, '', {
      moreParams: {includeInactive: false, includeHidden: false},
      afterFill: () => {
        _.forEach(this.items, (item: any) => {
          item.selected = initSelLayoutIds.indexOf(item.id) > -1;
        });
        // Modal detectChanges() + AdnHttp viewRefresh race items.length 0→N;
        // publish template flags on the next macrotask with the spinner resolve.
        deferMarkForCheck(this.cdr, () => {
          this.displayItems = (this.items || []).slice();
          this.hasItems = this.displayItems.length > 0;
          this.canLoadMore = !!this.makeQuery && this.totalCount > this.displayItems.length;
          this.listReady = true;
        });
      }
    });
  }

  select(item: any): void {
    item.selected = true;
    this.selLayouts.push(item);
  }

  deselect(item: any): void {
    item.selected = false;
    _.remove(this.selLayouts, (l: any) => l.id === item.id);
    _.forEach(this.items, (it: any) => {
      if (it.id === item.id) {
        it.selected = false;
      }
    });
  }

  saveChanges(): void {
    this.onSaved.next(this.selLayouts);
    this.bsModalRef.hide();
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }

  translate(key: string): string {
    return this.translateService.instant(key);
  }
}
